/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { METADATA } from "../enums";
import { ICopyData } from "./CopyPaste.types";

export function OnCopyData(): <
	T,
	Descriptor extends TypedPropertyDescriptor<(event: ClipboardEvent) => ICopyData>
>(
	target: T,
	propertyKey: string | symbol,
	descriptor: Descriptor
) => Descriptor {
	return (target, propertyKey, descriptor) => {
		Reflect.defineMetadata(
			METADATA.ON_COPY_DATA,
			[ ...(Reflect.getMetadata(METADATA.ON_COPY_DATA, target) || []), propertyKey ],
			target
		);

		return descriptor;
	};
}
